"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _components = require("@folio/stripes/components");
var _NoResultsMessage = _interopRequireDefault(require("../../NoResultsMessage"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const TableBody = _ref => {
  var _query$sort;
  let {
    data,
    error,
    fetchNextPage,
    filterPaneVisible,
    intlKey: passedIntlKey,
    intlNS: passedIntlNS,
    isError,
    isLoading,
    labelOverrides = {},
    match,
    mclProps,
    onSort,
    path,
    resultColumns,
    toggleFilterPane,
    query
  } = _ref;
  const sortOrder = (_query$sort = query.sort) !== null && _query$sort !== void 0 ? _query$sort : '';
  const history = (0, _reactRouterDom.useHistory)();
  const location = (0, _reactRouterDom.useLocation)();
  const onNeedMoreData = (_askAmount, index) => {
    fetchNextPage({
      pageParam: index
    });
  };

  // Build the map of column definitions
  const columnMapping = Object.fromEntries(resultColumns.map(e => [e.propertyPath, e.label]));

  // Build the list of visible columns
  const visibleColumns = resultColumns.map(e => e.propertyPath);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.MultiColumnList, {
    autosize: true,
    columnMapping: columnMapping,
    contentData: data === null || data === void 0 ? void 0 : data.results,
    hasMargin: true,
    isEmptyMessage: /*#__PURE__*/(0, _jsxRuntime.jsx)(_NoResultsMessage.default, {
      error,
      filterPaneIsVisible: filterPaneVisible,
      intlKey: passedIntlKey,
      intlNS: passedIntlNS,
      isError,
      isLoading,
      labelOverrides,
      searchTerm: query.query,
      toggleFilterPane
    }),
    isSelected: _ref2 => {
      var _match$params;
      let {
        item
      } = _ref2;
      return item.id === (match === null || match === void 0 || (_match$params = match.params) === null || _match$params === void 0 ? void 0 : _match$params.id);
    },
    onHeaderClick: onSort,
    onNeedMoreData: onNeedMoreData,
    onRowClick: (_e, rowData) => {
      history.push("".concat(path, "/").concat(rowData === null || rowData === void 0 ? void 0 : rowData.id).concat(location === null || location === void 0 ? void 0 : location.search));
    },
    pagingType: "click",
    sortDirection: sortOrder.startsWith('-') ? 'descending' : 'ascending',
    sortOrder: sortOrder.replace(/^-/, '').replace(/,.*/, ''),
    totalCount: data.totalRecords,
    visibleColumns: visibleColumns,
    ...mclProps
  });
};
TableBody.propTypes = {
  data: _propTypes.default.shape({
    totalRecords: _propTypes.default.number,
    results: _propTypes.default.arrayOf(_propTypes.default.object)
  }),
  error: _propTypes.default.object,
  fetchNextPage: _propTypes.default.func,
  filterPaneVisible: _propTypes.default.bool,
  history: _propTypes.default.object,
  intlKey: _propTypes.default.string,
  intlNS: _propTypes.default.string,
  isError: _propTypes.default.bool,
  isLoading: _propTypes.default.bool,
  labelOverrides: _propTypes.default.object,
  location: _propTypes.default.object,
  match: _propTypes.default.object,
  mclProps: _propTypes.default.object,
  onSort: _propTypes.default.func,
  path: _propTypes.default.string.isRequired,
  query: _propTypes.default.object,
  resultColumns: _propTypes.default.arrayOf(_propTypes.default.object),
  toggleFilterPane: _propTypes.default.func
};
var _default = exports.default = TableBody;